module.exports = __webpack_public_path__ + "img/bg_curve.f9c5eb91.svg";